'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultMessage = undefined;

var _constants = require('./../constants');

var defaultMessage = exports.defaultMessage = {
    title: 'modalErrorAuthDefaultLine1',
    text: 'modalErrorAuthDefaultLine2',
    whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
};


var errorMessageList = {
    'error.authentication.credentials.bad': {
        title: 'modalErrorAuthCredentialsBadLine1',
        text: 'modalErrorAuthCredentialsBadLine2',
        whereToDisplay: _constants.CALL_DISPLAY_LOGIN_FORM
    },
    'error.authentication.self.excluded': {
        title: 'modalErrorAuthSelfExcludedLine1',
        text: 'modalErrorAuthSelfExcludedLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.locked': {
        title: 'modalErrorAuthLockedLine1',
        // TODO: when function launchLiveChat is ready change this message
        // text: 'modalErrorAuthLockedLine2',
        text: 'modalErrorAuthInactiveLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.account.closed': {
        title: 'modalErrorAuthClosedLine1',
        text: 'modalErrorAuthClosedLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.closedByPlayer': {
        title: 'modalErrorAuthClosedByPlayerLine1',
        text: 'modalErrorAuthInactiveLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.self.excluded.finished': {
        title: 'modalErrorAuthSelfExcludedFinishedLine1',
        text: 'modalErrorAuthSelfExcludedFinishedLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.timeout': {
        title: 'modalErrorAuthTimeoutLine1',
        text: 'modalErrorAuthTimeoutLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.oxi.error': {
        title: 'modalErrorAuthOxiErrorLine1',
        text: 'modalErrorAuthOxiErrorLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.db.error': {
        title: 'modalErrorAuthDbErrorLine1',
        text: 'modalErrorAuthDbErrorLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.invalid.loginticket': {
        title: 'modalErrorInvalidLoginTicketLine1',
        text: 'modalErrorInvalidLoginTicketLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.channel.blocked': {
        title: 'modalErrorAuthRestrictedLine1',
        text: 'modalErrorAuthRestrictedLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.account.inactive': {
        title: 'modalErrorAuthInactiveLine1',
        text: 'modalErrorAuthInactiveLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.age.verification.suspended': {
        title: 'modalErrorAuthRestrictedLine1',
        text: 'modalErrorAuthRestrictedLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    },
    'error.authentication.max.linked.accounts': {
        title: 'modalErrorAuthMaxLinkedAccountsLine1',
        text: 'modalErrorAuthMaxLinkedAccountsLine2',
        whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
    }
};

var loadErrorMessage = function loadErrorMessage(action) {
    if (action.error && action.error.failure && errorMessageList[action.error.failure]) {
        return errorMessageList[action.error.failure];
    } else if (action.error && action.error.success === false) {
        return {
            title: 'modalErrorAuthMaxLoginAttemptsLine1',
            text: 'modalErrorAuthMaxLoginAttemptsLine2',
            whereToDisplay: _constants.CALL_DISPLAY_MESSAGE
        };
    }

    return defaultMessage;
};

exports.default = loadErrorMessage;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/utils.js
// module id = 262
// module chunks = 0